import { IoArrowBackCircleSharp } from "react-icons/io5";
import { useState, useContext } from "react";
import { Link } from "react-router-dom";
import { useSpring, animated } from "@react-spring/web";
import useFetch from "../../hooks/useFetch";
import LanguageContext from "../../context/language-context";

export default function MobileDropDown(props) {
  const [showsub, SetShowSub] = useState(false);
  const [showLettiSub, SetShowLettiSub] = useState(false);
  const [showLettiKidSub, SetShowLettiKidSub] = useState(false);
  const [showAcastelloSub, SetShowAcastelloSub] = useState(false);
  const translations = {
    en: {
      Bagno: "Bathroom Furniture",
      Lavabi: "Washbasins",
      Piani: "Top",
      Doccia: "Shower",
    },
    fr: {
      Bagno: "Meuble Salle de bain",
      Lavabi: "vasque",
      Piani: "Plan",
      Doccia: "Douche",
    },
    it: {
      Bagno: "Mobili Bagno",
      Lavabi: "Lavabi",
      Piani: "Piani",
      Doccia: "Doccia",
    },
    de: {
      Bagno: "Badmoebel",
      Lavabi: "Waschbecken",
      Piani: "Pläne",
      Doccia: "Dusche",
    },
    es: {
      Bagno: "Muebles de baño",
      Lavabi: "Lavabos",
      Piani: "Planes",
      Doccia: "Ducha",
    },
  };
  const ToggleSubMenu = (event) => {
    event.preventDefault();
    SetShowSub((prev) => !prev);
  };
  const ToggleLettiSubMenu = (event) => {
    event.preventDefault();

    SetShowLettiSub((prev) => !prev);
  };
  const ToggleLettiKidSubMenu = (event) => {
    event.preventDefault();

    SetShowLettiKidSub((prev) => !prev);
  };
  const ToggleAcastelloSubMenu = (event) => {
    event.preventDefault();

    SetShowAcastelloSub((prev) => !prev);
  };

  const springs = useSpring({
    from: { x: 100 },
    to: { x: 0 },
  });

  const languageCtx = useContext(LanguageContext);
  const {
    loading,
    error,
    data: bagni,
  } = useFetch(
    `https://spagnoladmin.lavallearredobagno.it/api/bagnis?locale=${languageCtx.languageData}&populate=*`
  );
  const {
    loading: loading1,
    error: error1,
    data: lavanderia,
  } = useFetch(
    `https://spagnoladmin.lavallearredobagno.it/api/lavanderias?locale=${languageCtx.languageData}`
  );
  const {
    loading: loading2,
    error: error2,
    data: livings,
  } = useFetch(
    `https://spagnoladmin.lavallearredobagno.it/api/livings?locale=${languageCtx.languageData}`
  );
  const {
    loading: loading3,
    error: error3,
    data: lavabi,
  } = useFetch(
    `https://spagnoladmin.lavallearredobagno.it/api/lavabis?locale=${languageCtx.languageData}`
  );
  const {
    loading: loading4,
    error: error4,
    data: piani,
  } = useFetch(
    `https://spagnoladmin.lavallearredobagno.it/api/pianis?locale=${languageCtx.languageData}`
  );
  const {
    loading: loading5,
    error: error5,
    data: specchi,
  } = useFetch(
    `https://spagnoladmin.lavallearredobagno.it/api/specchis?locale=${languageCtx.languageData}`
  );
  const {
    loading: loading6,
    error: error6,
    data: lampade,
  } = useFetch(
    `https://spagnoladmin.lavallearredobagno.it/api/lampades?locale=${languageCtx.languageData}`
  );
  const {
    loading: loading7,
    error: error7,
    data: miscelatori,
  } = useFetch(
    `https://spagnoladmin.lavallearredobagno.it/api/miscelatoris?locale=${languageCtx.languageData}`
  );
  const {
    loading: loading8,
    error: error8,
    data: doccia,
  } = useFetch(
    `https://spagnoladmin.lavallearredobagno.it/api/doccias?locale=${languageCtx.languageData}`
  );
  if (
    loading8 ||
    loading7 ||
    loading6 ||
    loading5 ||
    loading4 ||
    loading3 ||
    loading2 ||
    loading1 ||
    loading
  )
    return <p>Loading...</p>;

  return (
    <animated.div
      className={`items ${props.isopen ? "showing" : ""}`}
      style={{ ...springs }}
    >
      <div className="columns">
        <a href="#" className="backone heading" onClick={props.ToggleMenu}>
          <IoArrowBackCircleSharp /> Back to menu
        </a>
        <br />
        <ul className="menu-items">
          <li>
            <a
              onClick={ToggleSubMenu}
              id="amadi-1"
              className="battenti underline-hover-effect"
              href="#"
            >
              {translations[languageCtx.languageData].Bagno}
            </a>
            <ul id="submenu-1" className={`${showsub ? "show" : "hide"}`}>
              {bagni.data.map((item, index) => {
                let productDescription = item.attributes.Page_Name;

                if (productDescription.includes("-")) {
                  productDescription = productDescription.split("-").join(" ");
                }

                // Determine the route path and component name based on the condition
                let routePath;
                if (item.attributes.Product_name_and_Image.length === 1) {
                  // If there's only one element in the array, use a different component
                  routePath = `bagni/${item.attributes.url}/${item.attributes.url}`;
                } else {
                  // Otherwise, use the default component
                  routePath = `bagni/${item.attributes.url}`;
                }

                return (
                  <li key={index}>
                    <Link
                      to={routePath}
                      className="ardeco"
                      onClick={() => localStorage.setItem("link", "bagnis")}
                    >
                      {productDescription}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </li>
          <li>
            {lavanderia.data.map((item, index) => {
              let productDescription = item.attributes.Page_Name;

              if (productDescription.includes(`-`)) {
                productDescription = productDescription.split(`-`).join(` `);
              }
              return (
                <Link
                  id="submenu-main"
                  to={`lavanderia/${item.attributes.url}`}
                  className="ardeco underline-hover-effect"
                  key={index}
                >
                  {productDescription}
                </Link>
              );
            })}
          </li>
          <li>
            <a
              onClick={ToggleLettiSubMenu}
              id="amadi-1"
              className="battenti underline-hover-effect"
              href="#"
            >
              {translations[languageCtx.languageData].Lavabi}
            </a>
            <ul id="submenu-1" className={`${showLettiSub ? "show" : "hide"}`}>
              {lavabi.data.map((item, index) => {
                let productDescription = item.attributes.Page_Name;

                if (productDescription.includes(`-`)) {
                  productDescription = productDescription.split(`-`).join(` `);
                }
                return (
                  <li key={index}>
                    <Link
                      id="submenu-main"
                      to={`lavabi/${item.attributes.url}`}
                      className="ardeco underline-hover-effect"
                      key={index}
                    >
                      {productDescription}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </li>
          <li>
            <a
              onClick={ToggleLettiKidSubMenu}
              id="amadi-1"
              className="battenti underline-hover-effect"
              href="#"
            >
              {translations[languageCtx.languageData].Piani}
            </a>
            <ul
              id="submenu-1"
              className={`${showLettiKidSub ? "show" : "hide"}`}
            >
              {piani.data.map((item, index) => {
                let productDescription = item.attributes.Page_Name;

                if (productDescription.includes(`-`)) {
                  productDescription = productDescription.split(`-`).join(` `);
                }
                return (
                  <li key={index}>
                    <Link
                      id="submenu-main"
                      to={`piani/${item.attributes.url}`}
                      className="ardeco underline-hover-effect"
                      key={index}
                    >
                      {productDescription}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </li>
          <li>
            <ul className="single-submenu-item-menu-list"></ul>
          </li>
          <li>
            {specchi.data.map((item, index) => {
              let productDescription = item.attributes.Page_Name;

              if (productDescription.includes(`-`)) {
                productDescription = productDescription.split(`-`).join(` `);
              }
              return (
                <Link
                  id="submenu-main"
                  to={`specchi/${item.attributes.url}`}
                  className="ardeco underline-hover-effect"
                  key={index}
                >
                  {productDescription}
                </Link>
              );
            })}
          </li>
          <li>
            {lampade.data.map((item, index) => {
              let productDescription = item.attributes.Page_Name;

              if (productDescription.includes(`-`)) {
                productDescription = productDescription.split(`-`).join(` `);
              }
              return (
                <Link
                  id="submenu-main"
                  to={`lampade/${item.attributes.url}`}
                  className="ardeco underline-hover-effect"
                  key={index}
                >
                  {productDescription}
                </Link>
              );
            })}
          </li>
          <li>
            {miscelatori.data.map((item, index) => {
              let productDescription = item.attributes.Page_Name;

              if (productDescription.includes(`-`)) {
                productDescription = productDescription.split(`-`).join(` `);
              }
              return (
                <Link
                  id="submenu-main"
                  to={`miscelatori/${item.attributes.url}`}
                  className="ardeco underline-hover-effect"
                  key={index}
                >
                  {productDescription}
                </Link>
              );
            })}
          </li>
          <li>
            <a
              onClick={ToggleAcastelloSubMenu}
              id="amadi-1"
              className="battenti underline-hover-effect"
              href="#"
            >
              {translations[languageCtx.languageData].Doccia}
            </a>
            <ul
              id="submenu-1"
              className={`${showAcastelloSub ? "show" : "hide"}`}
            >
              {doccia.data.map((item, index) => {
                let productDescription = item.attributes.Page_Name;

                if (productDescription.includes(`-`)) {
                  productDescription = productDescription.split(`-`).join(` `);
                }
                return (
                  <li key={index}>
                    <Link
                      id="submenu-main"
                      to={`doccia/${item.attributes.url}`}
                      className="ardeco underline-hover-effect"
                      key={index}
                    >
                      {productDescription}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </li>
        </ul>
      </div>
    </animated.div>
  );
}
